// Action creators extracted from CoachMarksModule.js

import React from "react";
import { UPDATE_DATA, UPDATE_COACHMARK_STATUS } from "./CoachMarksConstants";

// Action Creators
export const updateCoachMarksData = value => {
  return { type: UPDATE_DATA, payload: value };
};

export const updateCoachMarkViewStatus = value => {
  return { type: UPDATE_COACHMARK_STATUS, payload: value };
};
